import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import HeaderNav from "./HeaderNav";
import SideNav from "./SideNav";
import Footer from "./Footer";

import { getuserProfile } from "../../store/slices/auth";

export default function AdminDashboardlayout() {
  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.auth);

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState("Dashboard");

  // ==============================
  // Fetch profile only once
  // ==============================
  useEffect(() => {
    if (!profile) {
      dispatch(getuserProfile());
    }
  }, [dispatch, profile]);

  // ==============================
  // Responsive sidebar
  // ==============================
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="app-wrapper">

      {/* ==============================
          SIDEBAR
      ============================== */}
      <SideNav
        open={sidebarOpen}
        toggle={() => setSidebarOpen((prev) => !prev)}
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
      />

      {/* ==============================
          MAIN SECTION
      ============================== */}
      <div className={`main-section ${sidebarOpen ? "shift" : ""}`}>

        {/* HEADER */}
        <HeaderNav
          onMenuClick={() => setSidebarOpen((prev) => !prev)}
        />

        {/* CONTENT */}
        <main className="content">
          <Outlet />
        </main>

        {/* FOOTER */}
        <Footer />

      </div>
    </div>
  );
}